import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import EsimImage from 'shared/images/esim.webp'
import InsuranceImage from 'shared/images/insurance.webp'
import TouraikaImage from 'shared/images/touraika.webp'
import { sendGtagEvent } from 'shared/lib/analytics'

import { ServiceTile } from './ui/service-tile'

import s from './styles.module.scss'

type ServiceName = 'medical_insurance' | 'esim' | 'turaika'

export const TripServices = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    sendGtagEvent('VIEW_TRAVEL_SERVICES')
  }, [])

  const onSelectService = (serviceName: ServiceName, path: string) => {
    sendGtagEvent('SELECT_TRAVEL_SERVICE', { service_name: serviceName })
    navigate(path)
  }

  return (
    <div className={s.container}>
      <ServiceTile
        title={t('trip_services.insurance')}
        image={InsuranceImage}
        onClick={() =>
          onSelectService('medical_insurance', RoutingPaths.insurance.path())
        }
      />

      <ServiceTile
        title={t('trip_services.esim')}
        image={EsimImage}
        badge={t('trip_services.new')}
        onClick={() => onSelectService('esim', RoutingPaths.esim.path())}
      />

      <ServiceTile
        title={t('trip_services.touraika')}
        image={TouraikaImage}
        onClick={() => onSelectService('turaika', RoutingPaths.touraika.path())}
      />
    </div>
  )
}
